<div class="row row-sm add-form">
    <form [formGroup]="FeeForm">
        <div class="card-body">
                <div class="col-sm-12 text-center">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/receipt.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h2 class="main-content-label mb-1 ml-2"><b>Admission Fee Process
                                </b>
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="row clearfix">
                    <div class="table-responsive table-container mt-4 ">
                        <table  class="table table-bordered text-nowrap">
                            <thead>
                                <tr>
                                    <th width="20%" class="f600">Head</th>
                                    <th width="20%" class="f600">Head Name</th>
                                    <th width="20%" class="f600">Fee Amount</th>
                                    <!-- <th width="20%" class="f600">Due Amount</th>
                                            <th width="20%" class="f600">Payable Amount</th> -->
    
                                </tr>
                            </thead>
    
                            <tbody id="table_data" formArrayName="feeHeadArray">
                                <!-- examSemList -->
                                <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last "
                                    [formGroupName]="i">
                                    <!--  -->
                                    <td>
                                        <input class="form-control  input-sm" readonly formControlName="FeeHead"
                                            maxlength="8" id="addone">
    
                                    </td>
                                    <td>
                                        <input class="form-control input-sm" formControlName="HeadName" readonly>
                                    </td>
                                    <td  *ngIf="Currency == 'INR' ">
                                        <span class="currency-symbolTd">&#8377; </span>
                                        <input class="form-control  mrrr input-sm" formControlName="FeeAmt" readonly>
                                    </td>
                                    <td  *ngIf="Currency == 'USD' ">
                                        <span class="currency-symbolTd">$</span>
                                        <input class="form-control mrrr  input-sm" formControlName="FeeAmt" readonly>
                                    </td>
                                    <!-- <td>
                                                <input class="form-control input-sm" formControlName="FeeDue" readonly>
                                                <input class="form-control input-sm" type="hidden" formControlName="FeeDueDummy" readonly>
                                            </td>
                                            <td>
                                                <input class="form-control input-sm" (ngModelChange)="onInputChange($event,i)" 
                                                    formControlName="FeePaid" maxlength="8" id="addone">
                                                  </td> -->
    
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-sm-12 row">
                        <div class="col-sm-9 mrg11" *ngIf="Currency == 'INR' ">
                            <span class="Text">Total Amount :</span><span class="currency-symbol">&#8377;{{totalAmount}}
                            </span>
                        </div>
                        <div  class="col-sm-9 mrg11"  *ngIf="Currency == 'USD' ">
                            <span class="Text">Total Amount :</span><span class="currency-symbol">${{totalAmount}}
                            </span>
                        </div>
                        <br>
                      
                    </div>
                    <!-- <div class="col-sm-12 row"   *ngIf="submitButton">
                        <div class="col-sm-3">

                        </div>
                        
                        <div class="col-sm-6 mrg mrg1" *ngIf="Currency == 'INR' ">
                            
                            <br>
    
                            <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">&#8377;</span>
                            </span>
    
                            <mat-form-field appearance="outline" class="example-full-width col-sm-3">
                                <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                                    formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">
                                
                            </mat-form-field>
                            
                            <mat-error class="margin_tp ml1" *ngIf="zeroError">
                                Enter Valid Amount.
                            </mat-error>
                            <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                                    Amount Should Not Be Greater Than Remainig Amount.
                                </mat-error>
                                <mat-error class="margin_tp ml1" *ngIf="showEqualMessage">
                                    Please Pay Full Amount.
                                 </mat-error>
                                 
                                <mat-error class="margin_tp err"
                                    *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                                    This Field Is Mandatory.
                                </mat-error>
                                <mat-error class="margin_tp err"
                                    *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                                    Please Enter Valid Data.
                                </mat-error>
                        </div>
    
                        <div class="col-sm-6 mrg mrg1" *ngIf="Currency == 'USD' ">
                            <br>
    
                            <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">$</span>
                            </span>
    
                            <mat-form-field appearance="outline" class="example-full-width col-sm-3">
                                <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                                    formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">
                                
                            </mat-form-field>
                            <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                                    Amount Should Not Be Greater Than Remainig Amount.
                                </mat-error>
                                <mat-error class="margin_tp ml1" *ngIf="showEqualMessage">
                                    Please Pay Full Amount.
                                 </mat-error>
                                 
                                <mat-error class="margin_tp err"
                                    *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                                    This Field Is Mandatory.
                                </mat-error>
                                <mat-error class="margin_tp err"
                                    *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                                    Please Enter Valid Data.
                                </mat-error>
                        </div>
                    </div> -->

                    <!-- <div class="col-sm-12"  *ngIf="Currency == 'INR' && submitButton">
                        <span class="Text mrg5">Total Remaining Amount :</span>
                        <span class="currency-symbolTd">&#8377;{{remainAmt}}</span>
                    </div>
                    <div class="col-sm-12"  *ngIf="Currency == 'USD'  && submitButton">
                        <span class="Text mrg5">Total Remaining Amount :</span><span
                            class="currency-symbol Textmrg1">${{remainAmt}}</span>
                    </div> -->
                    <!-- <div class="col-sm-12 mrg">
                                <span class="Text">Total Amount :</span><span
                                        class="currency-symbol Textmrg">&#8377;{{totalAmount}} </span>
                             </div> -->
                    <!-- <div class="col-sm-12 mrg">
                                <span class="Text">Total Paid Amount :</span><span
                                        class="currency-symbol Textmrg11">
                                        <input class="form-control txt inputnew" (input)="onInputChange2($event)" formControlName="totalPaidFee" ></span>
                                       
                             </div>
                             <div class="col-sm-12 mrg">
                                <span class="Text">Total Remaining Amount :</span><span
                                        class="currency-symbol Textmrg1">&#8377;{{remainAmt}}</span>
                                        
                             </div> -->
                    <!-- <div class="row col-sm-12 mr1">
                                <div class="col-sm-6 mr2">
                                    <span class="Text mr3">Total Pay Amount :</span>
                                 </div>
                                    <input  class="col-sm-2 form-control input-sm"
                                        formControlName="TotalPaidAmount" (input)="onInputChange2()">
                            </div> -->
                    <div class="col-sm-12">
                        <button type="button" *ngIf="updateButton"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="openHistoryPopup()">
                            <span style="display: contents; align-items: center;">
                                <img width="22vh" src="../../assets/img/history.gif" style="margin-right: 5px;">
                                Payment History
                            </span>
                        </button>
                        <!-- <button type="button" *ngIf="updateButton " [disabled]="updateBtn"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1 fr" (click)="updateFeeTemplet()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
                                Save
                            </span>
                        </button> -->
                        <!-- [disabled]="updateBtn" -->
                        <button type="button"  *ngIf="submitButton && feeCreate"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFeeTemplet()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                            (click)="close()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/letter-x.gif" style="margin-right: 7px;">
                                Close
                            </span>
                        </button>
                    </div>
                </div>
            
        </div>
    </form>
</div>